// components/Services.js (actualizado)
import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const Services = () => {
    const services = [
        "Desarrollo de aplicaciones web (frontend y backend)",
        "Integración de sistemas y automatización de procesos",
        "Mantenimiento, soporte y evolución de plataformas digitales",
        "Consultoría tecnológica y diseño de soluciones a medida"
    ];

    return (
        <section id="servicios" className="py-16 bg-gray-50">
            <div className="container mx-auto px-6">
                <ScrollAnimation>
                    <h2 className="text-3xl font-bold font-poppins text-grafito mb-8 text-center">Qué hacemos</h2>
                </ScrollAnimation>
                <div className="max-w-4xl mx-auto">
                    <ScrollAnimation delay={0.2}>
                        <p className="text-lg text-grafito font-lato mb-8 text-center">
                            Desarrollamos aplicaciones web y soluciones digitales personalizadas para entidades públicas, adaptadas a sus procesos, objetivos y usuarios.
                        </p>
                    </ScrollAnimation>
                    <ScrollAnimation delay={0.3}>
                        <h3 className="text-xl font-semibold font-montserrat text-grafito mb-4">Servicios principales:</h3>
                    </ScrollAnimation>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {services.map((service, index) => (
                            <ScrollAnimation key={index} delay={0.4 + index * 0.1}>
                                <li className="flex items-start bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                                    <span className="text-lima mr-2 text-xl">•</span>
                                    <span className="text-grafito font-lato">{service}</span>
                                </li>
                            </ScrollAnimation>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Services;
